export default [
    {
      path: '/',
      name: '_home',
      component: () => import('@/views/home/home.vue')
    },
    {
      path: '/appDownload',
      name: 'app-download',
      component: () => import('@/views/app-download/app-download.vue')
    },
    {
      path: '/appDownload2',
      name: 'app-download2',
      component: () => import('@/views/app-download2/app-download2.vue')
    },
    {
      path: '/appDownload3',
      name: 'app-download3',
      component: () => import('@/views/app-download3/app-download3.vue')
    },
    {
      path: '/appDownloadNew',
      name: 'app-download-new',
      component: () => import('@/views/app-download-new/app-download-new.vue')
    },
    {
      path: '/appTlxq',
      name: 'app-tlxq',
      component: () => import('@/views/app-tlxq/app-tlxq.vue')
    },
    {
      path: '/appTlxq2',
      name: 'app-tlxq2',
      component: () => import('@/views/app-tlxq2/app-tlxq2.vue')
    }
  ]
  


// WEBPACK FOOTER //
// ./src/router/routers.js